module.exports = __webpack_public_path__ + "static/img/arrow-down-white.47b6bf72.svg";